import { FormControl, Validators } from '@angular/forms';
import {
  EoCustomControlConfig,
  EoDatepickerConfig,
  EoDropdownConfig,
  EoFormPanelConfig,
  EoInputConfig,
} from 'ngx-eo-web-components';
import { amkaValidator } from '../../core/validators/amka.validator';
import { surgeryStatuses } from '../../shared/components/surgery-status-dropdown/surgery-status-dropdown.config';
import { is } from 'date-fns/locale';

export const privateSurgerySearchForm = new EoFormPanelConfig({
  name: 'form',
  panelContentStyleClass: 'grid',
  config: [
    new EoCustomControlConfig({
      name: 'hospitalID',
      label: 'Νοσοκομείο',
      styleClass: 'col-6',
      control: new FormControl(null, [Validators.required]),
    }),
    new EoCustomControlConfig({
      name: 'clinicID',
      label: 'Κλινική',
      styleClass: 'col-6',
      control: new FormControl(null),
    }),
    new EoDatepickerConfig({
      name: 'dateFrom',
      styleClass: 'col-6',
      label: 'Ημ. αποδέσμευσης από',
      showClear: false,
      appendTo: 'body',
      control: new FormControl(),
      showButtonBar: true,
      placeholder: 'Παρακαλώ επιλέξτε ημερομηνία',
    }),
    new EoDatepickerConfig({
      name: 'dateTo',
      styleClass: 'col-6',
      label: 'Ημ. αποδέσμευσης έως',
      showClear: false,
      appendTo: 'body',
      control: new FormControl(),
      showButtonBar: true,
      placeholder: 'Παρακαλώ επιλέξτε ημερομηνία',
    }),
    new EoInputConfig({
      name: 'patientAmka',
      styleClass: 'col-6',
      type: 'text',
      label: 'ΑΜΚΑ Ασθενούς',
      placeholder: 'Παρακαλώ συμπληρώστε το ΑΜΚΑ Ασθενούς',
      control: new FormControl(null),
    }),
  ],
});

export const privateSurgerySearchFormConfig: EoFormPanelConfig[] = [
  privateSurgerySearchForm,
];

const setFc = (formGroupName: string, formControlName: string, value: any) => {
  privateSurgerySearchFormConfig
    .find((cfc) => cfc.name === formGroupName)
    ?.config?.find((c) => c.name === formControlName)
    ?.control?.setValue(value);
};

const disableFc = (formGroupName: string, formControlName: string) => {
  privateSurgerySearchFormConfig
    .find((cfc) => cfc.name === formGroupName)
    ?.config?.find((c) => c.name === formControlName)
    ?.control?.disable();
};

const enableFc = (formGroupName: string, formControlName: string) => {
  privateSurgerySearchFormConfig
    .find((cfc) => cfc.name === formGroupName)
    ?.config?.find((c) => c.name === formControlName)
    ?.control?.enable();
};

export const initSurgerySearchForm = (
  hospitalId?: string | null,
  clinicId?: string | null,
  isClinicAdmin: boolean = false
): void => {
  initHospitalAndClinicDP(hospitalId, clinicId);
  handleHospitalFc(hospitalId);
  handleClinicFc(clinicId, isClinicAdmin);
};

function handleClinicFc(
  clinicId: string | null | undefined,
  isClinicAdmin = false
) {
  if (clinicId && isClinicAdmin) {
    disableFc('form', 'clinicID');
  } else {
    enableFc('form', 'clinicID');
  }
}

function handleHospitalFc(hospitalId: string | null | undefined) {
  if (hospitalId) {
    disableFc('form', 'hospitalID');
  } else {
    enableFc('form', 'hospitalID');
  }
}

function initHospitalAndClinicDP(
  hospitalId: string | null | undefined,
  clinicId: string | null | undefined
) {
  setFc('form', 'hospitalID', hospitalId);
  setFc('form', 'clinicID', clinicId);
}

export function setSearchParams(savedSearchParams: any) {
  setFc('form', 'dateFrom', savedSearchParams.dateFrom);
  setFc('form', 'dateΤο', savedSearchParams.dateΤο);
  setFc('form', 'patientAmka', savedSearchParams.patientAmka);
}
